import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ASSET_WRITE, canUserShare, hasPrivilege } from 'utils/privileges';
import createLocation from 'utils/createLocation';
import { NavMenu, NavMenuButton, NavMenuDivider, NavMenuItem, NavMenuList } from 'components/NavMenu';
import useBreakpoints from 'hooks/useBreakpoints';
import AssetViewer from 'screens/SimpleAssetViewer';
import { ChangelogOption, GetShareableContentLinkOption, ShareContentOption } from 'screens/SinglePlaylistManager';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function AssetHeaderOptionsMenu(_ref) {
  var _ref$hasOpenOption = _ref.hasOpenOption,
    hasOpenOption = _ref$hasOpenOption === void 0 ? true : _ref$hasOpenOption,
    asset = _ref.asset,
    parentPlaylistId = _ref.parentPlaylistId,
    shareData = _ref.shareData,
    _ref$isBlockedByPlayl = _ref.isBlockedByPlaylistChanges,
    isBlockedByPlaylistChanges = _ref$isBlockedByPlayl === void 0 ? false : _ref$isBlockedByPlayl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints('m'),
    isDesktop = _useBreakpoints.m;
  var location = useLocation();
  var navigate = useNavigate();
  var canShareAsset = !asset.isDeleted && canUserShare();
  var hasMenu = canShareAsset || hasPrivilege(ASSET_WRITE);
  if (!hasMenu) {
    return null;
  }
  function openAsset() {
    navigate(createLocation(location, {
      assetId: asset.id
    }));
  }
  return /*#__PURE__*/_jsxs(NavMenu, {
    id: "advanced-options-menu",
    menuPlacement: "bottom-end",
    children: [/*#__PURE__*/_jsx(NavMenuButton, {
      variant: "transparent",
      iconRight: "tools",
      iconOnly: !isDesktop,
      children: t('actions_more_options')
    }), /*#__PURE__*/_jsxs(NavMenuList, {
      children: [canShareAsset && shareData && /*#__PURE__*/_jsx(ShareContentOption, {
        shareData: shareData,
        modalQueryParam: "share-asset",
        isDisabled: isBlockedByPlaylistChanges,
        note: isBlockedByPlaylistChanges ? t('alert_save_changes_before_sharing') : undefined
      }), canShareAsset && /*#__PURE__*/_jsx(GetShareableContentLinkOption, {
        contentId: asset.id,
        parentPlaylistId: parentPlaylistId,
        type: "asset",
        modalQueryParam: "share-asset-link"
      }), hasPrivilege(ASSET_WRITE) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [canShareAsset && /*#__PURE__*/_jsx(NavMenuDivider, {}), /*#__PURE__*/_jsx(ChangelogOption, {
          contentId: asset.id
        })]
      }), hasOpenOption && /*#__PURE__*/_jsx(NavMenuItem, {
        onClick: openAsset,
        children: t('actions_open')
      })]
    }), /*#__PURE__*/_jsx(AssetViewer, {})]
  });
}
export default AssetHeaderOptionsMenu;